var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55433 3.41818C9.55433 4.91939 8.33736 6.13636 6.83615 6.13636C5.33494 6.13636 4.11797 4.91939 4.11797 3.41818C4.11797 1.91697 5.33494 0.7 6.83615 0.7C8.33736 0.7 9.55433 1.91697 9.55433 3.41818Z",
    stroke: "#51CDA0",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83633 12.9722H6.83627L6.83581 12.9722L6.8328 12.9722L6.81958 12.9722L6.76542 12.9719C6.71742 12.9715 6.64621 12.9707 6.55511 12.969C6.37285 12.9658 6.11142 12.9592 5.79732 12.9462C5.16736 12.9199 4.3336 12.8676 3.50501 12.764C2.6659 12.6591 1.87667 12.5068 1.31397 12.2958C1.03038 12.1895 0.851513 12.0852 0.754703 12.0005C0.723737 11.9734 0.707808 11.9547 0.700162 11.9439C0.711198 11.2854 1.28698 10.4103 2.48109 9.64765C3.64459 8.90458 5.22375 8.39043 6.83636 8.39043C8.44898 8.39043 10.0281 8.90458 11.1916 9.64765C12.3858 10.4103 12.9615 11.2854 12.9726 11.9439C12.9649 11.9547 12.949 11.9734 12.918 12.0005C12.8212 12.0852 12.6423 12.1895 12.3588 12.2958C11.7961 12.5068 11.0068 12.6591 10.1677 12.764C9.33913 12.8676 8.50537 12.9199 7.8754 12.9462C7.56131 12.9592 7.29988 12.9658 7.11762 12.969C7.02652 12.9707 6.95531 12.9715 6.90731 12.9719L6.85315 12.9722L6.83993 12.9722L6.83692 12.9722L6.83646 12.9722H6.83639H6.83633ZM0.693938 11.9329C0.6942 11.933 0.695331 11.9348 0.696546 11.9385C0.694284 11.9348 0.693676 11.9329 0.693938 11.9329ZM12.9788 11.9329C12.979 11.9329 12.9784 11.9348 12.9762 11.9385C12.9774 11.9348 12.9785 11.933 12.9788 11.9329Z",
    stroke: "#51CDA0",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.45627840a3441bbe064e05693327249a.svg";
export { ForwardRef as ReactComponent };